var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.get_subaccounts.length > 0)?_c('Header'):_vm._e(),(_vm.get_show_app_views)?_c('router-view'):_vm._e(),(_vm.get_sidebar_isOpened)?_c('Sidebar',{on:{"click":_vm.closeFilter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }